import { FaireAcademyGuide } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/types";
import { useGuidesWithLikes } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/useGuidesWithLikes";
import { useMemo } from "react";

const getNextGuide = (
  currentGuide: FaireAcademyGuide,
  guides: Array<FaireAcademyGuide>
) => {
  if (currentGuide.title !== guides[guides.length - 1]!.title) {
    const currentGuideIndex = guides.findIndex(
      (guide) => guide.title === currentGuide.title
    );
    const nextGuideIndex = currentGuideIndex + 1;
    const nextGuide = guides[nextGuideIndex];
    return nextGuide;
  }
  return undefined;
};

export const useGetNextGuide = (currentGuide: FaireAcademyGuide) => {
  const guidesWithLikes = useGuidesWithLikes();
  return useMemo<FaireAcademyGuide | undefined>(() => {
    return getNextGuide(currentGuide, guidesWithLikes);
  }, [currentGuide, guidesWithLikes]);
};

export const useGetOtherGuides = (
  currentGuide: FaireAcademyGuide,
  isLastChapter: boolean
) => {
  const guidesWithLikes = useGuidesWithLikes();
  const startingGuideTitle = useMemo<string | undefined>(() => {
    if (!isLastChapter) {
      return currentGuide.title;
    }
    return getNextGuide(currentGuide, guidesWithLikes)?.title;
  }, [currentGuide, guidesWithLikes, isLastChapter]);

  return useMemo<Array<FaireAcademyGuide>>(() => {
    const guidesWithOverflow = guidesWithLikes.concat(guidesWithLikes);
    const startIndex =
      guidesWithLikes.findIndex((guide) => {
        return guide.title === startingGuideTitle;
      }) + 1;

    return guidesWithOverflow.slice(startIndex, startIndex + 3);
  }, [startingGuideTitle, guidesWithLikes]);
};
